import React, { Component } from "react";
import client from "@culturehq/client";
import { Info, Pagination, Subnav } from "@culturehq/components";

import { t, Trans } from "app/utils";

import PageHeader from "components/display/PageHeader";

import FlagRow from "./flags/FlagRow";

class Flags extends Component {
  state = { flags: null, pagination: {}, reviewed: false };

  componentDidMount() {
    const { match } = this.props;

    this.fetchFlags(match.params.page || 1);
  }

  componentDidUpdate(prevProps, prevState) {
    const { match } = this.props;
    const { reviewed } = this.state;

    if (match.params.page !== prevProps.match.params.page) {
      this.fetchFlags(match.params.page || 1);
    } else if (reviewed !== prevState.reviewed) {
      this.fetchFlags(1);
    }
  }

  handlePageClick = page => {
    const { history } = this.props;

    history.push(`/admin/flags/${page}`);
  };

  handleFilterChange = index => {
    this.setState({ reviewed: index === 1 });
  };

  handleToggleReviewed = async toggledFlag => {
    await client.updateFlag({ flagId: toggledFlag.id, reviewed: !toggledFlag.reviewed });

    this.setState(({ flags }) => ({
      flags: flags.filter(flag => flag.id !== toggledFlag.id)
    }));
  };

  handleDeleted = deletedFlag => {
    this.setState(({ flags }) => ({
      flags: flags.filter(flag => flag.id !== deletedFlag.id)
    }));
  };

  async fetchFlags(page) {
    const { reviewed } = this.state;
    const { flags, pagination } = await client.listFlags({ reviewed, page });

    this.setState({ flags, pagination });
  }

  render() {
    const { flags, pagination } = this.state;

    return (
      <>
        <PageHeader title={t("REVIEW FLAGGED CONTENT")}>
          <Trans>
            Below is a list of all content that users have flagged as
            inappropriate, with optional notes included by the user. Each item
            may either be marked as reviewed or deleted from the platform.
          </Trans>
        </PageHeader>

        <Subnav onChange={this.handleFilterChange}>
          <Subnav.Item>
            <Trans>Non-Reviewed Content</Trans>
          </Subnav.Item>
          <Subnav.Item>
            <Trans>Reviewed Content</Trans>
          </Subnav.Item>
        </Subnav>

        <div className="AdminFlags__header-row row clearfix">
          <div className="col-sm-6">
            <Trans>Flagged Content</Trans>
          </div>
          <div className="col-sm-3">
            <Trans>Flagged By</Trans>
          </div>
          <div className="col-sm-3">
            <Trans>Actions</Trans>
          </div>
        </div>

        <hr />

        {flags && flags.map((flag, index) => (
          <FlagRow
            key={flag.id}
            flag={flag}
            isLast={index === flags.length - 1}
            onToggleReviewed={this.handleToggleReviewed}
            onDeleted={this.handleDeleted}
          />
        ))}

        {flags && flags.length < 1 && (
          <Info>
            <Trans>No flagged content.</Trans>
          </Info>
        )}

        <Pagination {...pagination} onClick={this.handlePageClick} />
      </>
    );
  }
}

export default Flags;
